<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Kunststof kozijnen</h1>

      <p>
        Kunststof kozijnen hebben de laatste jaren aan populariteit gewonnen en
        dat is uiteraard niet voor niets: kunststof is een relatief betaalbare
        materiaalsoort waaraan een aantal aantrekkelijke voordelen vastzitten.
        Op die voordelen, maar ook op de nadelen, gaan we hieronder in. Zijn
        kunststof kozijnen aan u besteed of passen aluminium of houten kozijnen
        toch beter bij uw smaak en woning? Daarover kunt u zich op
        Kozijnenvergelijker.nl uitgebreid laten informeren.
      </p>

      <p>
        Waarom zijn kunststof kozijnen terug te vinden in steeds meer woningen?
        We hebben de belangrijkste voordelen voor u op een rijtje gezet:
      </p>

      <ul>
        <li>Betaalbaarheid</li>
        <li>Hoge isolatiewaarde</li>
        <li>Keuze uit de meest uiteenlopende kleuren</li>
        <li>
          Keuze uit verschillende patronen, zodat u bijvoorbeeld kunststof
          kozijnen met het uiterlijk van hout kunt laten plaatsen
        </li>
        <li>Kunststof kozijnen gaan over het algemeen tientallen jaren mee</li>
        <li>Nauwelijks onderhoud</li>
      </ul>

      <p>
        Het grootste bezwaar tegen kunststof kozijnen is het uiterlijk. Als u
        een liefhebber bent van klassieke, natuurlijke kozijnen, is het goed
        mogelijk dat uw voorkeur uitgaat naar houten kozijnen. Houd er echter
        rekening mee dat kunststof kozijnen qua uiterlijk steeds dichter in de
        buurt komen van authentieke houten kozijnen! Het grootste verschil
        tussen kunststof en aluminium kozijnen zit ‘m in het uiterlijk:
        aluminium is gladder en oogt strakker.
      </p>

      <h2>Kunststof kozijnen vergelijken?</h2>

      <p>
        Sluiten kunststof kozijnen het beste aan op uw wensen? Vraag dan direct
        offertes aan bij verschillende leveranciers in uw eigen regio en
        verzeker uzelf ervan dat u een overeenkomst sluit met de leverancier die
        de aantrekkelijkste offerte heeft opgesteld. Op die manier bespaart u
        tot honderden euro’s op uw kunststof kozijnen!
      </p>
      <p>
        Nog niet volledig overtuigd van de voordelen van kunststof kozijnen?
        Lees dan ook de artikelen over
        <nuxt-link to="/informatie-over-kozijnen/aluminium">
          aluminium kozijnen
        </nuxt-link>
        en
        <nuxt-link to="/informatie-over-kozijnen/hout">
          houten kozijnen </nuxt-link
        >, weeg alle voor- en nadelen zorgvuldig tegen elkaar af, vraag binnen
        een paar minuten gratis en vrijblijvend offertes aan en geniet
        binnenkort van de mooiste <nuxt-link to="/"> kozijnen </nuxt-link> tegen
        de laagste prijs!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Kunststof kozijnen: de voor- en nadelen van kunststof!',
      headDescription:
        'Ben je van plan om kunststof kozijnen aan te schaffen? Op Kozijnenvergelijker.nl lees je alles over kunststof kozijnen en vergelijk je gratis offertes!',
      path: '/informatie-over-kozijnen/kunststof',
    }
  },
}
</script>
